export default "__VITE_ASSET__BCQ5ZkBF__"